import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './App.css';
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Partners from './components/Partners';
import AboutFacility from './components/AboutFacility';
import ProductsCatalog from './components/ProductsCatalog';
import WhyUs from './components/WhyUs';
import ContactRFQ from './components/ContactRFQ';
import Footer from './components/Footer';

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: "Hello! I'm your AI assistant. How can I help you with AB Engineering Works today?", isBot: true }
  ]);
  const [inputMessage, setInputMessage] = useState('');
  const [showContactForm, setShowContactForm] = useState(false);
  const [contactForm, setContactForm] = useState({ name: '', contact: '', query: '' });

  const handleSendMessage = () => {
    if (inputMessage.trim() === '') return;

    // Add user message
    const userMessage = { text: inputMessage, isBot: false };
    setMessages([...messages, userMessage]);
    setInputMessage('');

    // Simulate AI response
    setTimeout(() => {
      const botResponse = getBotResponse(inputMessage);
      setMessages(prev => [...prev, { text: botResponse, isBot: true }]);
    }, 1000);
  };

  const sendEmail = async (emailData) => {
    try {
      // Initialize EmailJS (you'll need to replace with your actual user ID)
      emailjs.init('nqO5yHw6zjGGzJW46'); // Replace with your EmailJS user ID
      
      const templateParams = {
        to_email: 'info@abenginworks.com',
        from_name: emailData.name,
        from_email: emailData.contact,
        message: emailData.query,
        original_question: emailData.originalQuestion
      };

      const response = await emailjs.send(
        'service_iy2g1ur', // Replace with your EmailJS service ID
        'template_ap0nqht', // Replace with your EmailJS template ID
        templateParams
      );

      if (response.status === 200) {
        console.log('Email sent successfully');
        return true;
      } else {
        console.error('Failed to send email');
        return false;
      }
    } catch (error) {
      console.error('Error sending email:', error);
      return false;
    }
  };

  const handleContactFormSubmit = async () => {
    if (contactForm.name.trim() === '' || contactForm.contact.trim() === '' || contactForm.query.trim() === '') {
      setMessages(prev => [...prev, { 
        text: "Please provide your name, contact details, and query.", 
        isBot: true 
      }]);
      return;
    }

    // Add loading message
    setMessages(prev => [...prev, { 
      text: "Sending your inquiry...", 
      isBot: true 
    }]);

    // Prepare email data
    const emailData = {
      name: contactForm.name,
      contact: contactForm.contact,
      query: contactForm.query,
      originalQuestion: messages[messages.length - 1].text
    };

    // Send email
    const emailSent = await sendEmail(emailData);

    if (emailSent) {
      setMessages(prev => [...prev, { 
        text: `Thank you ${contactForm.name}! Your inquiry has been sent to our team. We'll contact you at ${contactForm.contact} within 24 hours.`, 
        isBot: true 
      }]);
    } else {
      setMessages(prev => [...prev, { 
        text: `Thank you ${contactForm.name}! Your inquiry has been recorded. Please also contact us directly at 8108765006 or abengworks@yahoo.in for immediate assistance.`, 
        isBot: true 
      }]);
    }

    // Reset form
    setContactForm({ name: '', contact: '', query: '' });
    setShowContactForm(false);
  };


  const getBotResponse = (userMessage) => {
    const message = userMessage.toLowerCase();
    
    // Product/Service related questions
    if (message.includes('product') || message.includes('service') || message.includes('work') || 
        message.includes('manufacture') || message.includes('spare') || message.includes('parts') ||
        message.includes('burner') || message.includes('chuck') || message.includes('shaft') ||
        message.includes('assembly') || message.includes('device') || message.includes('machine')) {
      return `Here's our comprehensive product range:

🔥 All Types of Burners
⚙️ Upper Chuck Spares
⚙️ Lower Chuck Spares
🔧 Shafts
💻 Device Assemblies
🔨 Construction Devices
🏭 SM-3 Machine Spares
⭐ Custom-designed Parts

All parts are engineered for maximum efficiency and durability. For specific requirements or quotes, please contact us directly.`;
    }
    
    // Contact information
    else if (message.includes('contact') || message.includes('phone') || message.includes('call') || 
             message.includes('number') || message.includes('reach')) {
      return `📞 Contact Information:
Phone: 8108765006 | 9819214375
Email: abengworks@yahoo.in | abenginworks@gmail.com

We're here to help with all your inquiries!`;
    }
    
    // Location/Address
    else if (message.includes('location') || message.includes('address') || message.includes('where') || 
             message.includes('place') || message.includes('office')) {
      return `📍 Our Location:
A - 1/2, Shivaji industrial estate, chhabra compound, chhatrapati shivaji Maharaj Marg, Vakola bridge, Santacruz East, Mumbai -400055

Feel free to visit us or contact us for directions!`;
    }
    
    // Email
    else if (message.includes('email') || message.includes('mail')) {
      return `📧 Email Addresses:
• abengworks@yahoo.in
• abenginworks@gmail.com

You can also use info@abenginworks.com for general inquiries.`;
    }
    
    // Experience/Years
    else if (message.includes('experience') || message.includes('years') || message.includes('established') || 
             message.includes('since') || message.includes('how long')) {
      return `🏆 Experience:
AB Engineering Works has been in business since 1997, bringing nearly three decades of specialized expertise in pharmaceutical packaging machinery.

We have 28+ years of experience serving 25+ leading manufacturers in the industry.`;
    }
    
    // Pricing/Quotes
    else if (message.includes('price') || message.includes('quote') || message.includes('cost') || 
             message.includes('how much') || message.includes('pricing')) {
      return `💰 Pricing & Quotes:
For detailed pricing and quotes, please contact us directly:
• Phone: 8108765006 or 9819214375
• Email: abengworks@yahoo.in or abenginworks@gmail.com

We'll provide you with a comprehensive quote based on your specific requirements.`;
    }
    
    // Greetings
    else if (message.includes('hello') || message.includes('hi') || message.includes('hey')) {
      return `Hello! Welcome to AB Engineering Works. I'm here to help you with information about our services, products, or any other inquiries. What would you like to know?`;
    }
    
    // Unknown questions - show contact form
    else {
      setShowContactForm(true);
      return `I'd be happy to help you with that! To provide you with the most accurate information, could you please share your details? Our team will get back to you promptly.`;
    }
  };

  return (
    <div className="bg-light text-dark">
      {/* Chatbot */}
      <div className="chatbot-container">
        {isChatOpen && (
          <div className="chat-window">
            <div className="chat-header">
              <h6 className="mb-0">AB Engineering Assistant</h6>
              <button 
                className="btn-close" 
                onClick={() => setIsChatOpen(false)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="chat-messages">
              {messages.map((message, index) => (
                <div key={index} className={`message ${message.isBot ? 'bot' : 'user'}`}>
                  <div className="message-content">
                    {message.text}
                  </div>
                </div>
              ))}
              
              {showContactForm && (
                <div className="message bot">
                  <div className="message-content">
                    <div className="contact-form">
                      <div className="mb-3">
                        <label className="form-label small">Your Name:</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={contactForm.name}
                          onChange={(e) => setContactForm({...contactForm, name: e.target.value})}
                          placeholder="Enter your name"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label small">Contact Details (Phone/Email):</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={contactForm.contact}
                          onChange={(e) => setContactForm({...contactForm, contact: e.target.value})}
                          placeholder="Enter phone or email"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label small">Message:</label>
                        <textarea
                          className="form-control form-control-sm"
                          value={contactForm.query}
                          onChange={(e) => setContactForm({...contactForm, query: e.target.value})}
                          placeholder="Please describe your inquiry in detail"
                          rows="3"
                        ></textarea>
                      </div>
                      <button 
                        className="btn btn-primary btn-sm"
                        onClick={handleContactFormSubmit}
                      >
                        Submit Inquiry
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="chat-input">
              <input
                type="text"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                placeholder="Type your message..."
                className="form-control"
              />
              <button onClick={handleSendMessage} className="btn btn-primary">
                <i className="fas fa-paper-plane"></i>
              </button>
            </div>
          </div>
        )}
        <button 
          className="chat-toggle"
          onClick={() => setIsChatOpen(!isChatOpen)}
        >
          <i className="fas fa-comments"></i>
        </button>
      </div>

      {/* Top Utility Bar & Main Navigation */}
      <TopBar />
      <Navbar />

      {/* Hero Section */}
      <Hero />

      {/* Trusted Industry Partners */}
      <Partners />
      {/* About Us & Workshop Facility */}
      <AboutFacility />

      {/* B2B Spare Parts Catalog */}
      <ProductsCatalog />

      {/* Section 3: Core Expertise */}
      <section id="expertise" className="py-5 bg-white border-bottom">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold mb-3 text-primary">Core Expertise</h2>
            <p className="fs-5 text-muted">Delivering excellence through innovation and precision</p>
          </div>
          <div className="row g-4 justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="card h-100 border-0 shadow-sm hover-card">
                <div className="card-body text-center p-4">
                  <div className="bg-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-4" style={{width: '80px', height: '80px'}}>
                    <i className="fas fa-cogs fa-2x text-white"></i>
                  </div>
                  <h5 className="fw-bold mb-3 text-primary">Manufacturing Excellence</h5>
                  <p className="text-muted mb-0">Delivering performance-driven engineering solutions tailored to industry needs with meticulous attention to detail.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card h-100 border-0 shadow-sm hover-card">
                <div className="card-body text-center p-4">
                  <div className="bg-success rounded-circle d-inline-flex align-items-center justify-content-center mb-4" style={{width: '80px', height: '80px'}}>
                    <i className="fas fa-shield-alt fa-2x text-white"></i>
                  </div>
                  <h5 className="fw-bold mb-3 text-success">Uncompromising Quality</h5>
                  <p className="text-muted mb-0">Every component undergoes rigorous testing to meet the highest standards of durability and functionality, ensuring peak performance.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card h-100 border-0 shadow-sm hover-card">
                <div className="card-body text-center p-4">
                  <div className="bg-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-4" style={{width: '80px', height: '80px'}}>
                    <i className="fas fa-lightbulb fa-2x text-white"></i>
                  </div>
                  <h5 className="fw-bold mb-3 text-warning">Continuous Innovation</h5>
                  <p className="text-muted mb-0">Our in-house R&amp;D capabilities drive constant improvement, integrating the latest technological advancements into our products.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Section 4: Why Choose Us & Trust Guarantees */}
      <WhyUs />


      {/* Section 5: Workshop Contact & RFQ Form */}
      <ContactRFQ />

      {/* Modern B2B Corporate Footer */}
      <Footer />

      {/* Floating WhatsApp Quick Action Button */}
      <div className="whatsapp-float">
        <input type="checkbox" id="wa-fab-toggle" className="d-none" />
        <label htmlFor="wa-fab-toggle" className="wa-fab-label" title="Chat on WhatsApp">
          <i className="fab fa-whatsapp"></i>
        </label>
        <div className="wa-fab-menu">
          <a href="https://wa.me/918108765006" target="_blank" rel="noopener noreferrer" className="wa-fab-link">
            <i className="fab fa-whatsapp"></i> 8108765006
          </a><br></br>
          <a href="https://wa.me/919819214375" target="_blank" rel="noopener noreferrer" className="wa-fab-link">
            <i className="fab fa-whatsapp"></i> 9819214375
          </a>
        </div>
      </div>
    </div>

  );
}

export default App;


